import { getExpressPage, addExpress, updateExpress, delExpress } from '@/api/express'
import { message } from 'ant-design-vue'
import { OrderController } from './OrderController'
import { useEmitter } from '@/hooks'

export class ExpressController {
  static expressNames = [
    { name: '京东快递', expressCode: 'JD' },
    { name: '顺丰快递', expressCode: 'SF' },
    { name: '韵达快递', expressCode: 'YUNDA' },
    { name: '中通快递', expressCode: 'ZTO' },
    { name: '百世快递', expressCode: 'BEST' },
    { name: '申通快递', expressCode: 'STO' },
    { name: '圆通快递', expressCode: 'YTO' },
    { name: '中国邮政速递物流', expressCode: 'DB' },
    { name: '德邦快递', expressCode: 'EMS' },
    { name: '极兔快递', expressCode: 'JTSD' }
  ]

  static async page (params: COMMON.API.QueryParams) {
    const { code, data } = await getExpressPage(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async add (data: EXPRESS.Detail) {
    const { code, msg } = await addExpress(data)
    code === 0 ? message.success('新增成功') : message.error(msg)
    // 需要更新订单数
    if (code === 0) {
      useEmitter().emit('update-express-count')
      // await OrderController.getWaitExpressCount()
    }
    return code
  }

  static async update (data: EXPRESS.Detail) {
    const { code, msg } = await updateExpress(data)
    code === 0 ? message.success('编辑成功') : message.error(msg)
    return code
  }

  static async delById (id: string) {
    const { code, msg } = await delExpress(id)
    code === 0 ? message.success('删除功') : message.error(msg)
  }
}
